import { useNavigate } from "react-router-dom";
import { scrollToSection } from "../utils/scrollToSection";
import usePageTitle from "../hooks/usePageTitle";

export default function ProjectPage({
  title,
  category,
  tagline,
  body,
  art,
  tech = [],
  features = [],
  github,
  githubNote,
  demo,
  wip,
  frames,
}) {
  const navigate = useNavigate();
  usePageTitle(title);

  const handleBack = () => {
    navigate("/");
    setTimeout(() => {
      scrollToSection("projects");
    }, 50);
  };

  return (
    <main className="project-page">
      <button className="back-btn" onClick={handleBack}>
        ← Back
      </button>

      <header className="pp-hero">
        <p className="section-label">{category}</p>
        <h1>{title}</h1>
        <p className="pp-tagline">{tagline}</p>
        {wip && <span className="pp-badge">Work in progress</span>}
      </header>

      {art && (
        <div
          className="pp-hero-art"
          // backgroundImage (not the background shorthand) so the CSS
          // background-size/position drift animation isn't reset
          style={{ backgroundImage: art }}
        />
      )}

      <section className="pp-body">
        {body.map((paragraph, i) => (
          <p key={i}>{paragraph}</p>
        ))}
      </section>

      {(tech.length > 0 || features.length > 0) && (
        <section className="pp-meta">
          {tech.length > 0 && (
            <div className="pp-tech">
              <h2>Technologies</h2>
              <div className="edu-chips">
                {tech.map((t) => (
                  <span key={t} className="chip">
                    {t}
                  </span>
                ))}
              </div>
            </div>
          )}
          {features.length > 0 && (
            <div className="pp-features">
              <h2>Key features</h2>
              <ul className="pp-feature-list">
                {features.map((f) => (
                  <li key={f.title}>
                    <span className="pp-feature-title">{f.title}</span>
                    <span className="pp-feature-desc">{f.desc}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </section>
      )}

      <section className="pp-gallery">
        {frames.map((f) => (
          <figure key={f.label} className={`pp-frame pp-frame--${f.type}`}>
            {f.src ? (
              <img src={f.src} alt={f.label} />
            ) : (
              <figcaption className="pp-frame-label">{f.label}</figcaption>
            )}
          </figure>
        ))}
      </section>

      <footer className="pp-links">
        {github && (
          <a href={github} target="_blank" rel="noreferrer">
            GitHub ↗
          </a>
        )}
        {demo && (
          <a href={demo} target="_blank" rel="noreferrer">
            Live demo ↗
          </a>
        )}
        {!github && githubNote && (
          <span className="pp-private">{githubNote}</span>
        )}
      </footer>
    </main>
  );
}
